export default "__VITE_ASSET__C9VuAB6N__"